<p class="version" [attr.aria-hidden]="hidden" [ngClass]="{ hidden: hidden }">
  {{ product }} version {{ appVersion }} - (revision: {{ version }}-{{ revision }}-{{ npmVersion }})
</p>
